import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
    selector: 'gf-pager',
    template: require('./paging.component.html')
})
export class PagerComponent implements OnInit, OnChanges {
    @Input() items: any[];
    @Output() onpage: EventEmitter<any> = new EventEmitter<any>();
    
    get hasOnpageSubscribers(): boolean {
      return this.onpage.observers.length > 0;
    }

    pageNum: number;
    pageSize: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;

    constructor(private stateService: StateService) { }

    ngOnInit(): void {
        this.pageNum = parseInt(this.stateService.params.page_num, 10) || 1;
        this.pageSize = parseInt(this.stateService.params.page_size, 10) || 20;

        this.updatePageIndicators();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.items && !changes.items.firstChange) {
            this.pageNum = parseInt(this.stateService.params.page_num, 10) || 1;
            this.pageSize = parseInt(this.stateService.params.page_size, 10) || 20;
            this.updatePageIndicators();
        }
    }

    updatePageIndicators(): void {
        this.hasNextPage = _.get(this.items, 'length', 0) === this.pageSize;
        this.hasPreviousPage = this.pageNum > 1;
    }

    throwOnPage(params: any): void {
        this.onpage.emit(params); // Emit the event
    }

    goTo(params: any): Promise<any> {
        _.extend(this.stateService.params, params);

        //Delete keys with empty values
        _.forIn(params, function (value, key) {
            if (!value) {
                delete params[key];
            }
        });

       return this.stateService.go('.', params, { reload: true, notify: true, location: true, inherit: true })
        .then(() => {
            return params;
        });
    }
}
